class MainCollection {
  constructor(container) {
    this.container = container;

    // Dropdowns des filtres Search & Discovery
    this.dropdowns = Array.from(
      this.container.querySelectorAll('.filter-dropdown')
    );

    // Boutons de tags
    this.tagButtons = Array.from(
      this.container.querySelectorAll('.collection__tag-btn')
    );

    // Cartes produits wrapper
    this.products = Array.from(
      this.container.querySelectorAll('.product-card--collection')
    );

    // Bind des méthodes
    this.onTagClick = this.onTagClick.bind(this);
    this.onContainerClick = this.onContainerClick.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onCheckboxChange = this.onCheckboxChange.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);

    // Écouteurs
    this.container.addEventListener('click', this.onContainerClick);
    this.container.addEventListener('change', this.onCheckboxChange);
    document.addEventListener('click', this.onDocumentClick);
    document.addEventListener('keydown', this.onKeyDown); 

    this.tagButtons.forEach((btn) => {
      btn.addEventListener('click', this.onTagClick);
    });

    // Swiper
    this.initSlider();
    this.updateAllDropdownCounts();
    this.dropdowns.forEach((dd) => this.updateDropdownCount(dd));

    this.showMoreBtn = this.container.querySelector('.js-show-more');
    this.emptyTagMsg = this.container.querySelector('.main-collection__empty-tag');
    this.initShowMore();

    this.subtitleRte = this.container.querySelector('[data-subtitle-rte]');
    this.subtitleToggleBtn = this.container.querySelector('[data-subtitle-toggle]');
    this.subtitleExpanded = false;
    this.onResize = this.onResize.bind(this);
    window.addEventListener('resize', this.onResize);
    this.initSubtitleToggle();

  }

  initSlider() {
    // Slider des filtres Search & Discovery
    const slider = this.container.querySelector(
      '.main-collection__search-products.swiper'
    );
    if (slider) {
      this.filterSwiper = new Swiper(slider, {
        slidesPerView: 'auto',
        spaceBetween: 6,
        breakpoints: {
          989: {
            spaceBetween: 0,
          },
        },
      });
    }
  
    // Slider des tags
    const sliderTag = this.container.querySelector('.main-collection__tags.swiper');
    if (sliderTag) {
      this.tagSwiper = new Swiper(sliderTag, {
        slidesPerView: 'auto',
        spaceBetween: 6,
        freeMode: true,
        watchOverflow: false,
        breakpoints: {
          989: {
            spaceBetween: 12,
          },
        },
      });
    }
  }

  updateDropdownCount(dropdown) {
    const countEl = dropdown.querySelector('.filter-dropdown__count');
    if (!countEl) return;
  
    const checkedCount = dropdown.querySelectorAll(
      '.filter-dropdown__checkbox:checked'
    ).length;
  
    countEl.textContent = checkedCount;
  
    if (checkedCount > 0) {
      countEl.removeAttribute('hidden');
    } else {
      countEl.setAttribute('hidden', '');
    }
  }

  initShowMore() {
    if (!this.showMoreBtn) return;

    const isMobile = window.innerWidth < 990;
    const itemsPerRow = isMobile ? 2 : 4;
    const maxVisible = itemsPerRow * 5;

    this.products.forEach((product, index) => {
      if (index >= maxVisible) {
        product.classList.add('is-hidden');
      }
    });

    if (this.products.length <= maxVisible) {
      this.showMoreBtn.style.display = 'none';
      return;
    }

    this.showMoreExpanded = false;

    this.showMoreBtn.addEventListener('click', () => {
      if (!this.showMoreExpanded) {
        this.products.forEach((p) => p.classList.remove('is-hidden'));
        this.showMoreBtn.textContent = 'Voir moins';
        this.showMoreExpanded = true;
      } else {
        const mobile = window.innerWidth < 990;

        // TODO: UPDATE CARD COUNT VISIBLE
        const max = 20;
        this.products.forEach((p, i) => {
          if (i >= max) p.classList.add('is-hidden');
        });
        this.showMoreBtn.textContent = 'Voir plus';
        this.showMoreExpanded = false;

        this.container
          .querySelector('.main-collection__products')
          ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  initSubtitleToggle() {
    if (!this.subtitleRte || !this.subtitleToggleBtn) return;

    this.subtitleToggleBtn.addEventListener('click', () => {
      this.subtitleExpanded = !this.subtitleExpanded;
      this.updateSubtitleToggleState();
    });

    this.updateSubtitleToggleState();
  }

  updateSubtitleToggleState() {
    if (!this.subtitleRte || !this.subtitleToggleBtn) return;

    this.subtitleRte.classList.add('is-collapsed');
    const hasOverflow = this.subtitleRte.scrollHeight > this.subtitleRte.clientHeight + 1;

    if (!hasOverflow) {
      this.subtitleRte.classList.remove('is-collapsed');
      this.subtitleToggleBtn.hidden = true;
      this.subtitleExpanded = false;
      this.subtitleToggleBtn.textContent = 'Lire plus';
      return;
    }

    this.subtitleToggleBtn.hidden = false;

    if (this.subtitleExpanded) {
      this.subtitleRte.classList.remove('is-collapsed');
      this.subtitleToggleBtn.textContent = 'Voir moins';
    } else {
      this.subtitleRte.classList.add('is-collapsed');
      this.subtitleToggleBtn.textContent = 'Lire plus';
    }
  }

  onResize() {
    this.updateSubtitleToggleState();
  }
  
  
  
  updateAllDropdownCounts() {
    this.dropdowns.forEach((dd) => this.updateDropdownCount(dd));
  }
  
  

  toggleDropdown(dropdown) {
    const panel = dropdown.querySelector('.filter-dropdown__panel');
    const icon = dropdown.querySelector('.filter-dropdown__icon');
    const toggle = dropdown.querySelector('.filter-dropdown__toggle');
    const isOpen = panel && !panel.hasAttribute('hidden');
  
    this.closeAllDropdowns();
  
    if (panel && !isOpen) {
      panel.style.left = '';
      panel.style.right = '';
      panel.removeAttribute('hidden');
      if (icon) icon.classList.add('is-open');
      if (toggle) toggle.classList.add('is-open');
      this.adjustPanelPosition(panel);
    }
  }

  adjustPanelPosition(panel) {
    const rect = panel.getBoundingClientRect();
    if (rect.right > window.innerWidth) {
      panel.style.left = 'auto';
      panel.style.right = '0';
    }
  }
  

  closeAllDropdowns() {
    this.dropdowns.forEach((dd) => {
      const panel = dd.querySelector('.filter-dropdown__panel');
      const icon = dd.querySelector('.filter-dropdown__icon');
      const toggle = dd.querySelector('.filter-dropdown__toggle');

      if (panel) panel.setAttribute('hidden', '');
      if (icon) icon.classList.remove('is-open');
      if (toggle) toggle.classList.remove('is-open');
    });
  }

  /* --------- Gestion des filtres S&D cochés ---------- */

  clearFilter(dropdown) {
    dropdown
      .querySelectorAll('.filter-dropdown__checkbox')
      .forEach((input) => {
        input.checked = false;
        const option = input.closest('.filter-dropdown__option');
        if (option) option.classList.remove('is-checked');
      });

    this.updateDropdownCount(dropdown);

  }

  getAllSelections() {
    const selected = [];

    this.dropdowns.forEach((dd) => {
      dd
        .querySelectorAll('.filter-dropdown__checkbox:checked')
        .forEach((input) => {
          selected.push({
            paramName: input.dataset.paramName,
            value: input.dataset.value,
          });
        });
    });

    return selected;
  }

  applyFilters() {
    const url = new URL(window.location.href);
    const currentParams = new URLSearchParams(url.search);
    const params = new URLSearchParams();

    const sortBy = currentParams.get('sort_by');
    if (sortBy) {
      params.set('sort_by', sortBy);
    }

    const selections = this.getAllSelections();

    selections.forEach(({ paramName, value }) => {
      params.append(paramName, value);
    });

    url.search = params.toString();
    window.location = url.toString();
  }

  /* --------- FILTRES PAR TAGS (boutons du haut) ---------- */

  onTagClick(e) {
    const btn = e.currentTarget;
    const tag = btn.dataset.tag;
    const isAlreadyActive = btn.classList.contains('is-active');

    this.tagButtons.forEach((b) => b.classList.remove('is-active'));

    if (isAlreadyActive && tag !== '__all__') {
      const allBtn = this.tagButtons.find(b => b.dataset.tag === '__all__');
      if (allBtn) allBtn.classList.add('is-active');
      this.showAllProducts();
      return;
    }

    btn.classList.add('is-active');
    this.filterByTag(tag);
  }

  filterByTag(tag) {
    if (tag === '__all__') {
      this.showAllProducts();
      return;
    }
    let hasVisible = false;
    this.products.forEach((productEl) => {
      productEl.classList.remove('is-hidden');
      const tagsString = productEl.dataset.tags || '';
      const tagsArray = tagsString.split('|');
      const match = tagsArray.includes(tag);
      productEl.style.display = match ? '' : 'none';
      if (match) hasVisible = true;
    });
    if (this.showMoreBtn) {
      this.showMoreBtn.style.display = 'none';
    }
    if (this.emptyTagMsg) {
      if (hasVisible) {
        this.emptyTagMsg.setAttribute('hidden', '');
      } else {
        this.emptyTagMsg.removeAttribute('hidden');
      }
    }
  }

  showAllProducts() {
    this.products.forEach((productEl) => {
      productEl.style.display = '';
      productEl.classList.remove('is-hidden');
    });
    if (this.emptyTagMsg) {
      this.emptyTagMsg.setAttribute('hidden', '');
    }
    this.restoreShowMore();
  }

  restoreShowMore() {
    if (!this.showMoreBtn) return;
    const isMobile = window.innerWidth < 990;
    const itemsPerRow = isMobile ? 2 : 4;

    //TODO: UPDATE CARD COUNT VISIBLE
    const maxVisible = 20;
    if (this.products.length > maxVisible) {
      this.products.forEach((product, index) => {
        if (index >= maxVisible) {
          product.classList.add('is-hidden');
        }
      });
      this.showMoreBtn.style.display = '';
      this.showMoreBtn.textContent = 'Voir plus';
    } else {
      this.showMoreBtn.style.display = 'none';
    }
  }
  

  /* --------- Handlers généraux ---------- */

  onCheckboxChange(e) {
    const input = e.target.closest('.filter-dropdown__checkbox');
    if (!input || !this.container.contains(input)) return;
  
    const option = input.closest('.filter-dropdown__option');
    if (!option) return;
  
    if (input.checked) {
      option.classList.add('is-checked');
    } else {
      option.classList.remove('is-checked');
    }
  
    // 🔥 MISE À JOUR IMMÉDIATE DU COMPTEUR
    const dropdown = input.closest('.filter-dropdown');
    if (dropdown) {
      this.updateDropdownCount(dropdown);
    }
  }
  

  onContainerClick(e) {
    const toggle = e.target.closest('.filter-dropdown__toggle');
    const applyBtn = e.target.closest('.filter-dropdown__apply');
    const clearBtn = e.target.closest('.filter-dropdown__clear');

    if (toggle && this.container.contains(toggle)) {
      e.preventDefault();
      e.stopPropagation();
      const dropdown = toggle.closest('.filter-dropdown');
      if (dropdown) this.toggleDropdown(dropdown);
      return;
    }

    if (applyBtn && this.container.contains(applyBtn)) {
      e.preventDefault();
      e.stopPropagation();
      this.applyFilters();
      return;
    }

    if (clearBtn && this.container.contains(clearBtn)) {
      e.preventDefault();
      e.stopPropagation();
      const dropdown = clearBtn.closest('.filter-dropdown');
      if (dropdown) this.clearFilter(dropdown);
      return;
    }
  }

  onKeyDown(e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      this.closeAllDropdowns();
    }
  }
  

  onDocumentClick(e) {
    const clickedDropdown = e.target.closest('.filter-dropdown');
  
    if (!clickedDropdown || !this.container.contains(clickedDropdown)) {
      this.closeAllDropdowns();
    }
  }
  
}

// Instanciation pour chaque section main-collection
document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('[data-section-type="main-collection"]')
    .forEach((section) => {
      new MainCollection(section);
    });
});
